import http from '../common/http-auth'
import type {UserFormInputs,activeOrDeactiveProps} from '../components/types/types';


interface UserDeleteIds {
    "userId": number;
}
interface UserDeleteProps {
    "modifiedBy": number;
    "userLst": UserDeleteIds[];
}

interface ChangePasswordProps {
    "password": string;
    "confirmPassword": string;
    "userId"?: number;
  }

  
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllUsersData = async (clientId?: number,roleId?: number) => {
    const params = new URLSearchParams();

    // Add clientId if it's a valid number and not zero
    if (clientId != null && !isNaN(clientId) && clientId !== 0) {
        params.append('clientId', clientId.toString());
    }

    // Add roleId if it's a valid number and not zero
    if (roleId != null && !isNaN(roleId) && roleId !== 0) {
        params.append('roleId', roleId.toString());
    }

    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    const url = `/user/selectallusers${params.toString() ? `?${params.toString()}` : ''}`;
    // Send the GET request
    const response = await http.get(url);
    // Return the response
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const addUserData = async (data: UserFormInputs) => {
    const response = http.post(`/user/register`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getUserById = async (id?: string) => {
    const response = http.get(`/user/${id !== undefined ? id : ''}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateUserData = async (data: UserFormInputs) => {
    const response = http.put(`/user/update`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const deleteUserData = async (data: UserDeleteProps) => {
    const response = http.post(`/user/delete`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeUserPassword = async (data: ChangePasswordProps) => {
    const response = http.post(`/user/updatepassword`, data)
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const activateOrDeactivate = async (data: activeOrDeactiveProps) => {
    const response = http.post(`/user/activateordeactivate`, data)
    return response;
}